import { Box, Typography } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Logo from '../../assets/images/welcome-k2-logo.png';
import AuthBg from '../../assets/images/authBg.png';
import AuthBgText from '../../assets/images/authbg-text.png';

const AuthLayout = () => {
  const location = useLocation();

  return (
    <Box
      display={'flex'}
      sx={{
        maxWidth: '100%',
        '@media (max-width: 768px)': {
          background: `linear-gradient(0deg, #00AEEF 0%, rgba(0, 174, 239, 0.96) 21.74%, rgba(0, 174, 239, 0.94) 33.13%, rgba(0, 174, 239, 0.85) 44%, rgba(0, 174, 239, 0.72) 63.15%, rgba(0, 174, 239, 0.6) 84.89%, rgba(0, 174, 239, 0.24) 99.38%), url(${AuthBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
        },
      }}
      borderRadius={'4px'}
    >
      <Box
        sx={{
          maxWidth: '805px',
          width: '100%',
          backgroundImage: `linear-gradient(0deg, #00AEEF 0%, rgba(0, 174, 239, 0.96) 21.74%, rgba(0, 174, 239, 0.94) 33.13%, rgba(0, 174, 239, 0.85) 44%, rgba(0, 174, 239, 0.72) 63.15%, rgba(0, 174, 239, 0.6) 84.89%, rgba(0, 174, 239, 0.24) 99.38%), url(${AuthBg}) `,
          backgroundSize: 'cover',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            display: 'none',
          },
        }}
      >
        <Box>
          <img
            src={Logo}
            alt='auth-logo'
            style={{
              marginBottom: '36px',
            }}
          />
          <Typography
            fontSize={'40px'}
            lineHeight={'47px'}
            color={'#f1fbff'}
            fontWeight={'700'}
            sx={{
              borderBottom: '2px solid #CCEAF5',
            }}
          >
            KILLER TAX &
          </Typography>
          <Typography
            fontSize={'40px'}
            lineHeight={'47px'}
            color={'#f1fbff'}
            fontWeight={'700'}
          >
            WEALTH STRATEGIES
          </Typography>
        </Box>
      </Box>
      <Outlet />
    </Box>
  );
};

export default AuthLayout;
